// extracted by mini-css-extract-plugin
export default {"root":"styles_root__qye8j","textBlock":"styles_textBlock__HtWgY","firstLine":"styles_firstLine__ab+tc","secondLine":"styles_secondLine__8r+0Z"};